import React, { useState } from "react"
import {
  Container,
  Header,
  Content,
  Navbar,
  Logo,
  Contact,
  ContactItem,
  Menu,
  MenuItem,
  MenuLink,
  NavSearch,
  ActionButton,
} from "./style"
import { Icons, Modal, Search } from "components"

const NavigationBar = ({
  logo,
  phone,
  email,
  menu,
  actions,
  label,
}: INavigationBar) => {
  const [isOpenModal, setOpenModal] = useState(false)
  const onCloseModal = () => {
    setOpenModal(false)
  }

  return (
    <Container>
      <Header>
        <Content>
          <Logo>
            <img src={logo} alt="Logo" width={182} height={"auto"} />
          </Logo>
          <Contact>
            <ContactItem>
              <label>{label.phone}</label>
              <span>
                <a href={`tel:${phone}`}>{phone}</a>
              </span>
            </ContactItem>
            <ContactItem>
              <label>{label.email}</label>
              <span>
                <a href={`mailto:${email}`}>{email}</a>
              </span>
            </ContactItem>
          </Contact>
        </Content>
        <Navbar>
          <Menu>
            {menu.map(({ name, url }, k) => (
              <MenuItem key={k}>
                <MenuLink to={url}>{name}</MenuLink>
              </MenuItem>
            ))}
          </Menu>
          <NavSearch onClick={() => setOpenModal(true)}>
            <Icons.Search />
          </NavSearch>
          {actions.map(({ text, url }, k) => (
            <ActionButton key={k} to={url}>
              {text}
            </ActionButton>
          ))}
        </Navbar>
      </Header>
      <Modal visible={isOpenModal} onCancel={onCloseModal}>
        <Search />
      </Modal>
    </Container>
  )
}

export default NavigationBar
